import { render, staticRenderFns } from "./BenefitsMomentTemplate.vue?vue&type=template&id=3f2ba37c&"
import script from "./BenefitsMomentTemplate.vue?vue&type=script&lang=js&"
export * from "./BenefitsMomentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports